const common = {
  siteName: '亲亲漫画网',
  siteSlogan: '专注下拉式漫画阅读',
  nav: {
    home: '首页',
    category: '分类',
    about: '关于我们',
  },
  breadcrumb: {
    home: '首页',
  },
  footer: {
    about: '亲亲漫画网 —— 专注下拉式漫画阅读，为您提供海量免费日漫、韩漫、国漫资源。流畅的下拉式阅读体验，让您沉浸在漫画的世界里。',
    quickLinks: '快速链接',
    categories: '漫画分类',
    contact: '联系我们',
    copyright: '© 2024 亲亲漫画网 版权所有',
  },
};

export default common;